// Define a function to get Parasha info for a given date
export const getParashaForDate = // Define a function to get Parasha info for a given date
async function getParashaForDate(date) {
  try {
    // Format date as YYYY-MM-DD
    const isoDate = date.toISOString().split('T')[0];

    // Call Hebcal API (returns parasha info)
    const response = await fetch(`https://www.hebcal.com/shabbat/?cfg=json&geonameid=293397&start=${isoDate}&end=${isoDate}`);
    const data = await response.json();

    // Hebcal returns an array of items; filter for the parasha
    const parashaItem = data.items.find(item => item.category === 'parashat');
    if (!parashaItem) {
        const shabbatStr = formatLocalDate(getNextShabbat(date));
        const holidayItem = data.items.find(item => 
        item.category === 'holiday' &&
        item.date.split('T')[0] === shabbatStr
      );

      if (holidayItem) {
        return {
          hebrew: getHolidayName(holidayItem.title),
          transliterated: getHolidayName(holidayItem.title),
          book: getHumashFromParasha(holidayItem.title),
          isSpecialReading: true
        };
      }
      return {
        hebrew: 'בראשית',
        transliterated: 'Bereshit',
        book: 'בראשית',
        isSpecialReading: false
      };
    }
    let cleanParasha = parashaItem.hebrew.replace(/^פרשת\s*/, '');
    cleanParasha = cleanParasha.replace('־','-')
    const isConnected =cleanParasha.includes('-') && cleanParasha != "כי-תבוא";
    let firstParsha = cleanParasha;
    if (isConnected){
       firstParsha = cleanParasha.split('-')[0];
    }
    console.log("firstParsha ", firstParsha)
    const book = getHumashFromParasha(firstParsha);
    if (cleanParasha === 'תצוה') {
      cleanParasha = 'תצווה';
    }
    if (cleanParasha === 'בהעלתך') {
      cleanParasha = 'בהעלותך';
    }
     if (cleanParasha === 'שלח-לך') {
      cleanParasha = 'שלח';
    }
    if (cleanParasha === 'חוקת') {
      cleanParasha = 'חקת';
    }
    if (cleanParasha === 'פינחס') {
      cleanParasha = 'פנחס';
    }
    if (cleanParasha === 'כי-תבוא') {
      cleanParasha = 'כי תבוא';
    }
    return {
      hebrew: cleanParasha,
      transliterated: parashaItem.title,
      book: book,
      isSpecialReading: parashaItem.hebrew.includes('ראש חודש') || parashaItem.hebrew.includes('פורים'), // simple example
      isConnected: isConnected,
      firstParsha: firstParsha
    };

  } catch (error) {
    // fallback
    return {
      hebrew: 'בראשית',
      transliterated: 'Bereshit',
      book: 'בראשית',
      isSpecialReading: false
    };
  }
}
function formatLocalDate(date) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split('T')[0];
}
function getNextShabbat(date) {
  const d = new Date(date);
  const day = d.getDay(); // 0=Sun ... 6=Sat
  const diff = (6 - day + 7) % 7;
  d.setDate(d.getDate() + diff);
  return d;
}

function getHumashFromParasha(parasha) {
  const bereshit = [
    "בראשית","נח","לך לך","וירא","חיי שרה","תולדות",
    "ויצא","וישלח","וישב","מקץ","ויגש","ויחי"
  ];

  const shemot = [
    "שמות","וארא","בא","בשלח","יתרו","משפטים",
    "תרומה","תצוה","כי תשא","ויקהל","פקודי", "ויקהל-פקודי"
  ];

  const vayikra = [
    "ויקרא","צו","שמיני","תזריע","מצרע",
    "אחרי מות","קדשים","אמור","בהר","בחוקתי","תזריע-מזורע","אחרי מות-קדושים","בהר-בחוקתי"
  ];

  const bamidbar = [
    "במדבר","נשא","בהעלתך","שלח","קרח",
    "חקת","פינחס","חוקת","בלק","פנחס","מטות","מסעי","מטות-מסעי"
  ];

  const devarim = [
    "דברים","ואתחנן","עקב","ראה","שופטים",
    "כי תצא","כי תבוא","נצבים","וילך",
    "האזינו","וזאת הברכה","נצבים-וילך","כי-תבוא","כי-תצא"
  ];

  if (bereshit.includes(parasha)) return {"book_hebrew": "בראשית", "book_transliterated": "Bereshit"};
  if (shemot.includes(parasha)) return {"book_hebrew": "שמות", "book_transliterated": "Shemot"};
  if (vayikra.includes(parasha)) return {"book_hebrew": "ויקרא", "book_transliterated": "Vayikra"};
  if (bamidbar.includes(parasha)) return {"book_hebrew": "במדבר", "book_transliterated": "Bamidbar"};
  if (devarim.includes(parasha)) return {"book_hebrew": "דברים", "book_transliterated": "Devarim"};

  return {"book_hebrew": "חגים", "book_transliterated": "Holidays"};
}

function getHolidayName(holiday) {
  const names = [
    { match: 'ראש השנה', value: 'Rosh Hashana' },
    { match: 'יום כיפור', value: 'Yom Kippur' },
    { match: 'סוכות', value: 'Sukkot' },
    { match: 'שמחת תורה', value: 'Shemini Atzeret' },
    { match: 'פסח', value: 'Pesach' },
    { match: 'שבועות', value: 'Shavuot' },
  ];

  const found = names.find(item => holiday.includes(item.value));
  return found ? found.match : holiday;
}
